/*
 * The share token is a query parameter which is included if the
 * user nagivates from a shared facebook, twitter, or email link.
 * Example: https://hover.to/3d/929123?share_token=3GguQYSHGupXzjuGZzfD
 */
const SHARE_TOKEN_PARAM = 'share_token';

const EMAIL_STATES = {
  sending: {
    id: 'sending',
    textToDisplay: 'Sending...',
  },
  sent: {
    id: 'sent',
    textToDisplay: 'Message Sent',
  },
  readyToSend: {
    id: 'readyToSend',
    textToDisplay: 'Send',
  },
  notReadyToSend: {
    id: 'notReadyToSend',
    textToDisplay: 'Send',
  },
};

/**
 * The machete viewer needs to be instantiated with these options
 * in order to enable the feature which takes a screenshot of the 3D model.
 * The screenshot is taken when the user clicks the Share button.
 * For more context see here: https://hoverinc.atlassian.net/browse/NS-505
 */
const MACHETE_VIEWER_OPTS_FOR_CREATING_SHARE_SCREENSHOT = {
  useHemisphereLight: true,
  webgl: {
    context: {
      antialias: true,
      alpha: false,
      preserveDrawingBuffer: true,
      premultipliedAlpha: false,
      autoClear: false,
      powerPreference: 'high-performance',
    },
  },
};

export default {
  SHARE_TOKEN_PARAM,
  EMAIL_STATES,
  MACHETE_VIEWER_OPTS_FOR_CREATING_SHARE_SCREENSHOT,
};
